import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/api';

export const useCrossAnalysisStats = (dateRange?: { start_date?: string; end_date?: string }) => {
  return useQuery({
    queryKey: ['cross-analysis-stats', dateRange],
    queryFn: () => analyticsApi.getCrossAnalysisStats(dateRange),
  });
};